import React, { useEffect } from 'react';

const TrainModel = () => {
  useEffect(() => {
    window.location.href = 'mailto:contact@sessionloops.com?subject=Train%20and%20Release%20a%20Model';
  }, []);

  return null; // No UI is rendered
};

export default TrainModel;
